var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"flex items-center px-6 py-2.5 uppercase rounded font-semibold text-xs text-black text-opacity-70 focus:outline-none transition ease-in-out duration-150 hover:bg-opacity-80",class:_vm.isDisabled ? 'border border-gray-300' : 'bg-yellow-400'},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }